import { render, staticRenderFns } from "./NestedData.vue?vue&type=template&id=b5fe3b8a&scoped=true"
import script from "./NestedData.vue?vue&type=script&lang=js"
export * from "./NestedData.vue?vue&type=script&lang=js"
import style0 from "./NestedData.vue?vue&type=style&index=0&id=b5fe3b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe3b8a",
  null
  
)

export default component.exports